module.exports = __webpack_public_path__ + "img/hviezda1.a8c1ba5a.svg";